import React from "react";
import { useTranslation } from "react-i18next";
import "./PoliticsTimeline.css";

export default function CMTimeline() {
  const { t } = useTranslation();

  const timelineData = [
    {
      year: t("timeline_start"),
      text: t("timeline_start_text")
    },
    {
      year: t("timeline_progress"),
      text: t("timeline_progress_text")
    },
    {
      year: t("timeline_union_secretary"),
      text: t("timeline_union_secretary_text")
    },
    {
      year: t("timeline_vision"),
      text: t("timeline_vision_text")
    },
    {
      year: t("timeline_future"),
      text: t("timeline_future_text")
    }
  ];

  return (
    <div className="cm-timeline-wrapper">
      <h2 className="cm-timeline-title">{t("timeline_main_title")}</h2>

      {timelineData.map((item, index) => (
        <div
          className={`cm-timeline-row ${index % 2 === 0 ? "left" : "right"}`}
          key={index}
        >
          {/* Circle */}
          <div className="cm-timeline-icon">
            <div className="cm-timeline-circle">{index + 1}</div>
          </div>

          {/* Content */}
          <div className="cm-timeline-content">
            <h4>{item.year}</h4>
            <p>{item.text}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
